import { Init } from 'app/cross-cutting-concerns/authentication/components/Init/Init';
import { LoadingPage } from 'lib/components/LoadingPage/LoadingPage';

export const InitPage = (): JSX.Element => (
  <>
    <Init />
    <LoadingPage />
  </>
);
